import React, { Component } from 'react';
import { graphql, StaticQuery } from 'gatsby';
import ReactHtmlParser from 'react-html-parser';
import LazyLoad from 'react-lazyload';
import { Section, Image } from 'components';
import { data } from './logic';
import './Awards.scss';

class Awards extends Component {
  renderItems = loadedData =>
    data.map((item, index) => (
      <div className={'awards__item'} key={`award-${index}`}>
        <Image
          src={loadedData[item.image].childImageSharp.fluid}
          additionalClass={'awards__image'}
          style={{ width: 'auto', height: 'auto' }}
        />
        <div className={'awards__caption'}>
          {ReactHtmlParser(item.caption)}
        </div>
      </div>
    ));

  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            CSSReel: file(relativePath: { eq: "awards/logo-CSSreel.png" }) {
              childImageSharp {
                fluid(maxWidth: 140) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            GWA: file(relativePath: { eq: "awards/logo-GWA.png" }) {
              childImageSharp {
                fluid(maxWidth: 71) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            Honorable: file(
              relativePath: { eq: "awards/honorable-mention.png" }
            ) {
              childImageSharp {
                fluid(maxWidth: 150) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            Indigo: file(relativePath: { eq: "awards/logo-indigo.png" }) {
              childImageSharp {
                fluid(maxWidth: 125) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            Certificate: file(
              relativePath: { eq: "awards/mobile-excellence.png" }
            ) {
              childImageSharp {
                fluid(maxWidth: 150) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        `}
        render={loadedData => (
          <Section
            additionalClass={'awards'}
            containerClass={'awards__container'}
            spaceless
            fullwidth
          >
            <div className={'awards__list anim-fade-in-bottom'}>
              <LazyLoad once offset={200} height={300}>
                {this.renderItems(loadedData)}
              </LazyLoad>
            </div>
            <div className={'awards__backdrop'} />
          </Section>
        )}
      />
    );
  }
}

export default Awards;
